import {
  RiArrowLeftSLine,
  RiNotification2Line,
  RiCloseFill,
  RiRobot2Line,
} from "@remixicon/react";
import { Dropdown, Tooltip } from "flowbite-react";
import useStore from "../store/useStore";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { Routes } from "../utils/costants/routes";
import { Breadcrumb } from "flowbite-react";
import { useState, useEffect } from "react";
import FacebookLoginButton from "./FacebookLoginButton";
import GoogleLoginButton from "./GoogleLoginButton";
import { SupportWidget, useSupportWidget } from "@exagon/support-widget";
import { useTheme } from "../providers/ThemeProvider";
import AIChatWidget from "./AIChatWidget";


interface ShNavbarProps {
  isSideNavOpen: boolean;
  onDrawerBtnClick: () => void;
  showBack?: boolean;
  showBreadcrumb?: boolean;
  showStatsBreadcrumb?: boolean;
  showCampaignBreadcrumb?: boolean;
  onNotificationClick: () => void;
  unreadNotificationCount: number;
}

export default function ShNavbar({
  isSideNavOpen,
  onDrawerBtnClick,
  showBack = false,
  onNotificationClick,
  showCampaignBreadcrumb = false,
  showBreadcrumb = false,
  unreadNotificationCount,
}: ShNavbarProps) {
  const { restoreToInitialState, email } = useStore();
  const navigate = useNavigate();
  const router = useRouter();
  const [currentNav, setCurrentNav] = useState(0);
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  const { isSupportOpen, openSupport, closeSupport } = useSupportWidget();
  const { primaryColor, brandName, brandLabel } = useTheme();

  useEffect(() => {
    const unsubscribe = router.subscribe("onResolved", () => {
      switch ((router.latestLocation.search as any).tab) {
        case "recensioni":
          setCurrentNav(0);
          break;
        case "analisi":
          setCurrentNav(1);
          break;
        /* TODO: Casi emotion e booster commentati perché sezioni nascoste
        case "emotion":
          setCurrentNav(2);
          break;
        case "booster":
          setCurrentNav(3);
          break;
        */
        case "tutorial":
          setCurrentNav(0);
          break;
        case "faq":
          setCurrentNav(1);
          break;
        case "google":
          setCurrentNav(0);
          break;
        case "facebook":
          setCurrentNav(1);
          break;
        case "instagram":
          setCurrentNav(2);
          break;
        case "campaign_list":
          setCurrentNav(0);
          break;
        case "campaign_analysis":
          setCurrentNav(1);
          break;
        default:
          setCurrentNav(0);
          break;
      }
    });
    return () => unsubscribe();
  }, [router]);

  return (
    <nav
      className={`flex sticky top-0 z-20 flex-col justify-center items-center w-full bg-white h-[60px]`}
    >
      <div className="flex flex-row items-center justify-between w-full px-[25px] h-[60px] bg-white border-b border-b-secondaryColor-200">
        <div className="flex items-center">
          <button
            title="Side navigation"
            type="button"
            className={` relative left-0  h-10 w-10 self-center rounded bg-white opacity-100 sm:block lg:hidden mr-4 ${isSideNavOpen
              ? "visible opacity-100 [&_span:nth-child(1)]:w-6 [&_span:nth-child(1)]:translate-y-0 [&_span:nth-child(1)]:rotate-45 [&_span:nth-child(3)]:w-0 [&_span:nth-child(2)]:-rotate-45 "
              : ""
              }`}
            aria-haspopup="menu"
            aria-label="Side navigation"
            aria-expanded={isSideNavOpen ? true : false}
            aria-controls="nav-menu-1"
            onClick={onDrawerBtnClick}
          >
            <div className="absolute top-1/2 left-1/2 w-6 transform -translate-x-1/2 -translate-y-1/2">
              <span
                aria-hidden="true"
                className="absolute block h-0.5 w-9/12 -translate-y-2 transform rounded-full bg-slate-700 transition-all duration-300"
              ></span>
              <span
                aria-hidden="true"
                className="absolute block h-0.5 w-6 transform rounded-full bg-slate-900 transition duration-300"
              ></span>
              <span
                aria-hidden="true"
                className="absolute block h-0.5 w-1/2 origin-top-left translate-y-2 transform rounded-full bg-slate-900 transition-all duration-300"
              ></span>
            </div>
          </button>
          {showBack && (
            <span
              className="flex gap-2 items-center font-medium leading-normal cursor-pointer text-md"
              onClick={() => router.history.back()}
            >
              <RiArrowLeftSLine />
              Torna indietro
            </span>
          )}

          {showBreadcrumb && (
            <Breadcrumb aria-label="Default breadcrumb example">
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.REVIEW_PAGE,
                    search: { tab: "recensioni" },
                  });
                  setCurrentNav(0);
                }}
                className={`text-2xl font-medium  ${currentNav !== 0 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Recensioni
              </a>
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.REVIEW_PAGE,
                    search: { tab: "analisi" },
                  });
                  setCurrentNav(1);
                }}
                className={`text-2xl font-medium ${currentNav !== 1 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Analisi
              </a>
              {/* TODO: Sezioni Emotion e Review Booster nascoste
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.REVIEW_PAGE,
                    search: { tab: "emotion" },
                  });
                  setCurrentNav(2);
                }}
                className={`text-2xl font-medium ${currentNav !== 2 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Emotion
              </a>
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.REVIEW_PAGE,
                    search: { tab: "booster" },
                  });
                  setCurrentNav(2);
                }}
                className={`text-2xl font-medium ${currentNav !== 3 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Review booster
              </a>
              */}
            </Breadcrumb>
          )}

          {/* {showStatsBreadcrumb && (
            <Breadcrumb aria-label="Default breadcrumb example">
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.STATISTICHE,
                    search: { tab: "google" },
                  });
                  setCurrentNav(0);
                }}
                className={`text-2xl font-medium  ${currentNav !== 0 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Google
              </a>
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.STATISTICHE,
                    search: { tab: "facebook" },
                  });
                  setCurrentNav(1);
                }}
                className={`text-2xl font-medium ${currentNav !== 1 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Facebook
              </a>
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.STATISTICHE,
                    search: { tab: "instagram" },
                  });
                  setCurrentNav(2);
                }}
                className={`text-2xl font-medium ${currentNav !== 2 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Instagram
              </a>
            </Breadcrumb>
          )} */}

          {showCampaignBreadcrumb && (
            <Breadcrumb aria-label="Default breadcrumb example">
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.ADV,
                    search: { tab: "campaign_list" },
                  });
                  setCurrentNav(0);
                }}
                className={`text-2xl font-medium  ${currentNav !== 0 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Lista campagne
              </a>
              <div className="w-[1px] h-8 bg-secondaryColor-500 mx-4"></div>
              <a
                onClick={() => {
                  router.navigate({
                    to: Routes.ADV,
                    search: { tab: "campaign_analysis" },
                  });
                  setCurrentNav(1);
                }}
                className={`text-2xl font-medium ${currentNav !== 1 && "text-secondaryColor-400"} transition-all ease-in-out duration-300 cursor-pointer`}
              >
                Analisi campagne
              </a>
            </Breadcrumb>
          )}
        </div>

        <div className="flex relative justify-end items-center gap-3">
          {/* TODO: Calendario temporaneamente commentato
          <Tooltip content="Prenota con exagon">
            <button
              onClick={() => NiceModal.show(CalendlyModal)}
              className="flex items-center hidden-arrow text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30"
            >
              <RiCalendarLine className="w-6 h-6" />
            </button>
          </Tooltip>
          */}

          {/* Social Login Buttons */}
          {/* <div className="relative flex items-center space-x-2">
            <FacebookLoginButton className="mr-2" />
            <GoogleLoginButton className="mr-4" />
          </div> */}

          {/* AI Chat Button */}
          {["localhost", "127.0.0.1", "socialhub.exagonengineering.com"].includes(window.location.hostname) && (
            <Tooltip content="AI Assistant">
              <button
                onClick={() => setIsAIChatOpen(!isAIChatOpen)}
                className="flex items-center text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 box-border"
              >
                <RiRobot2Line className="w-6 h-6" />
              </button>
            </Tooltip>
          )}

          {/* Support Button */}
          <Tooltip content="Supporto">
            <button
              onClick={openSupport}
              className="flex items-center text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 box-border"
            >
              <i className="ri-customer-service-fill text-2xl"></i>
            </button>
          </Tooltip>

          <Tooltip content="Notifiche">
            <div className="flex relative item-center">
              <a
                className="hidden-arrow flex items-center text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 dark:text-neutral-200 dark:hover:text-neutral-300 dark:focus:text-neutral-300 [&.active]:text-black/90 dark:[&.active]:text-neutral-400"
                href="#"
                id="dropdownMenuButton1"
                role="button"
                data-twe-dropdown-toggle-ref
                aria-expanded="false"
              >
                <span className="[&>svg]:w-6 cursor-pointer">
                  <RiNotification2Line onClick={() => onNotificationClick()} />
                </span>
                {unreadNotificationCount > 0 && (
                  <span className="absolute -mt-3 ms-3 rounded-[0.37rem] bg-danger px-[0.45em] py-[0.2em] text-[0.6rem] leading-none text-white">
                    {unreadNotificationCount}
                  </span>
                )}
              </a>
            </div>
          </Tooltip>

          <Dropdown
            label=""
            className="z-20 text-sm font-normal rounded-lg text-secondaryColor-500"
            dismissOnClick={false}
            renderTrigger={() => (
              <span>
                <div
                  className="relative flex items-center justify-center w-[35px] h-[35px] rounded-full bg-shblue-500 cursor-pointer"
                  data-twe-dropdown-ref
                >
                  <span className="text-white font-bold text-sm uppercase">
                    {email ? email.charAt(0).toUpperCase() : ''}
                  </span>
                </div>
              </span>
            )}
          >
            <Dropdown.Item
              onClick={() => {
                restoreToInitialState();
                window.history.replaceState(null, "", Routes.LOGIN);
                navigate({ to: Routes.LOGIN });
              }}
            >
              Logout
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>

      {/* Support Widget */}
      <SupportWidget
        isOpen={isSupportOpen}
        onClose={closeSupport}
        baseUrl="https://www.exagonplus.com/help"
        primaryColor={primaryColor || "#f92f65"}
        brandName={brandName || "Exagon"}
        icon="🆘"
        width={400}
        height={600}
        showTriggerButton={false}
        draggable={true}
        position={{ x: 20, y: 20 }}
        zIndex={9999}
        className="support-widget-draggable"
        getParameters={() => ({
          userId: "current-user-id", // You can replace this with actual user data
          userName: "Current User", // You can replace this with actual user data
          currentPage: window.location.pathname,
          timestamp: new Date().toISOString(),
          sessionId: "session-" + Date.now(),
          brandLabel: brandLabel || "Support"
        })}
      />
      <AIChatWidget isOpen={isAIChatOpen} onClose={() => setIsAIChatOpen(false)} />
    </nav>
  );
}
